import { Badge } from 'antd'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Routing, { MenuItem, SideMenu } from '../../components/reusable/routing'

import { useInventory, useReports, useLatestPathname } from '../../modules.js'

import Lab from './Lab.js'
import XRay from './X-Ray.js'
import Procedures from './Procedures.js'
import Consultation from '../../components/pages/Consultation.js'

let menu = [
    {
        path: 'consultation',
        title: 'Consultation',
        component: () => (
            <Consultation
                specialty="Dental"
                requestDepartment="Dental"
                notificationDestination="Dental"
                path="/app/dental/consultation"
            />
        )
    },
    {
        path: 'procedures',
        title: 'Procedures',
        component: Procedures
    },
    {
        path: 'lab',
        title: 'Laboratory',
        component: Lab
    },
    {
        path: 'x-ray',
        title: 'X-Ray',
        component: XRay
    }
]

const storeName = "Dental Store"

const Dental = () => {
    const history = useHistory()
    const { user } = useSelector(state => state.application)
    const pathname = useLatestPathname()

    const [Reports, reports] = useReports("dental")

    const [Inventory, store, requests] = useInventory(storeName)

    useEffect(() => {
        if (user.stores.some(st => st.name === storeName) || user?.issuperuser)
            menu[4] = {
                path: 'inventory',
                title: props => 
                    <Badge className='w-12' count={ requests }>
                        <MenuItem condition={ props?.condition }>Inventory</MenuItem>
                    </Badge>,
                component: ({ path }) => <Inventory requireShift path={ path } storeName={ storeName } />
            }

        menu[5] = {
            path: 'reports',
            title: 'Reports',
            component: () => <Reports reports={ reports } department="dental" />
        }

        const target = `/app/dental/${menu[0].path}`
        if (!pathname.current.startsWith(target)) history.push(target)
    }, [user, reports])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Dental</p>
                <SideMenu namespace="dental" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="dental" menu={ menu } />
            </div>
        </div>
    )
}

export default Dental
